import styled from 'styled-components';

import DialogContentComponent from 'xpi-black-ui/Common/Dialog/compose/DialogContent/styles';

export const DialogContent = styled(DialogContentComponent)`
  & > div {
    display: block;
  }

  p {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 40px;
    }
  }

  button {
    margin: 40px 16px 0 0;
    display: inline-block;
  }
`;

export const DialogMsgs = styled.div`
  overflow: auto;
  max-height: 194px;

  .warning {
    font-size: 16px;
    color: rgb(224, 86, 94);
  }
`;
